import { useGlobalAuth } from '@headbox-ui/auth-hook'
import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'
import { ActorRoles, Link } from '.'
import {
  HOME_LINK,
  HELP_LINK
} from '../Constants'
import { useGlobalState } from '../Store'

export const account: Link = {
  href: `${HOME_LINK}/users/edit`,
  target: '_blank',
  title: 'Account'
}

export const help: Link = {
  href: HELP_LINK,
  target: '_blank',
  title: 'Help'
}

export const getCompanyLink = (companyID: number): Link => ({
  href: `${HOME_LINK}/companies/${companyID}/people`,
  target: '_blank',
  title: 'Company'
})

// Intended duplication as this is legacy functionality to be removed
export const getDashboardLink = (companyID: number): Link => ({
  href: `${HOME_LINK}/companies/${companyID}/bookings`,
  target: '_blank',
  title: 'Dashboard'
})

// Intended duplication as this is legacy functionality to be removed
export const getPeopleLink = (companyID: number): Link => ({
  href: `${HOME_LINK}/companies/${companyID}/people`,
  target: '_blank',
  title: 'Company'
})

// Intended duplication as this is legacy functionality to be removed
export const getSettingsLink = (companyID: number): Link => ({
  href: `${HOME_LINK}/companies/${companyID}/profile`,
  target: '_blank',
  title: 'Settings'
})

export const preferredVenues: Link = {
  href: `${HOME_LINK}/preferredvenues`,
  target: '_blank',
  title: 'Preferred Venues'
}

export interface ActorSession {
  user: UserResponseDto
  links: Link[]
  logout: {
    onClick?: () => void
    title: string
  }
}

export const useActorSession = (): ActorSession => {
  const [{ role, user }] = useGlobalState('session')
  const { logout: onClick } = useGlobalAuth()
  const logout = {
    onClick,
    title: 'Sign out'
  }

  if ([
    ActorRoles.BIZ_ADMIN,
    ActorRoles.BIZ_MANAGER
  ].includes(role)) {
    return {
      user,
      links: [account, getCompanyLink(user.companyID), help],
      logout
    }
  }

  if ([
    ActorRoles.BIZ_ADMIN_LEGACY,
    ActorRoles.BIZ_MANAGER_LEGACY
  ].includes(role)) {
    return {
      user,
      links: [
        preferredVenues, getDashboardLink(user.companyID), getPeopleLink(user.companyID),
        getSettingsLink(user.companyID),
        account, help
      ],
      logout
    }
  }

  if (user !== undefined) {
    return {
      user,
      links: [account, help],
      logout
    }
  }

  return null
}
